var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 80,
    viewBox: "0 0 130 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1019 14.9878C27.4387 10.7611 28.6828 8.12952 29.8321 7.092C33.0148 4.22042 37.4154 5.78326 38.351 6.00709C41.6376 6.79557 40.5689 1.60697 43.3887 0.552307C45.2679 -0.150463 46.8134 0.70859 48.0262 3.12947C49.0999 0.870923 50.7361 -0.16357 52.9349 0.0209446C56.2336 0.300238 57.3879 11.4427 61.9206 9.0037C66.4542 6.56366 72.0122 6.00608 74.3864 9.63185C74.8995 10.4163 75.0961 9.1993 78.5863 5.04419C82.0765 0.888063 85.5567 -0.94297 92.6964 1.4769C95.9427 2.57592 98.6122 5.55538 100.708 10.4143C100.708 17.3492 105.809 21.4549 116.01 22.7284C131.313 24.6391 119.435 41.0932 100.708 45.9117C81.9808 50.7313 38.8651 53.3327 15.468 41.1567C-0.130169 33.0411 3.41449 24.3174 26.1009 14.9878H26.1019Z",
    fill: "url(#paint0_linear_44_2301)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4722 76.271C80.055 76.271 92.6874 73.3467 92.6874 69.7394C92.6874 66.1321 80.055 63.2078 64.4722 63.2078C48.8894 63.2078 36.2571 66.1321 36.2571 69.7394C36.2571 73.3467 48.8894 76.271 64.4722 76.271Z",
    fill: "url(#paint1_linear_44_2301)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.675,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.107 77.8893C90.8928 83.211 18.4803 77.124 10.773 74.3442C7.02168 72.9901 3.64034 70.4442 0.629997 66.7055C0.293073 66.2874 0.0812946 65.7826 0.019135 65.2493C-0.0430247 64.7159 0.0469714 64.1759 0.278723 63.6916C0.510475 63.2072 0.874524 62.7984 1.3288 62.5122C1.78308 62.2261 2.30904 62.0743 2.84591 62.0745H129.383C132.009 69.0699 126.251 74.3412 112.107 77.8893Z",
    fill: "url(#paint2_linear_44_2301)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1233 52.2345L76.4743 40.9499C76.2461 40.6807 75.9625 40.4638 75.6429 40.3142C75.3233 40.1646 74.9752 40.0856 74.6223 40.0828H53.8745C53.1628 40.0828 52.4863 40.4094 52.0226 40.9499L42.3735 52.2345V58.4294H86.1233V52.2345Z",
    fill: "url(#paint3_linear_44_2301)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3892 58.6572L74.9439 48.8285C74.7397 48.5964 74.488 48.411 74.2059 48.2849C73.9237 48.1588 73.6177 48.0948 73.3087 48.0975H55.1881C54.5661 48.0975 53.9582 48.3556 53.5529 48.8285L45.1076 58.6572V64.0555H83.3892V58.6572Z",
    fill: "url(#paint4_linear_44_2301)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1233 65.5286C86.1233 66.3887 85.7361 67.162 85.1252 67.6803L85.0012 67.7811C84.5168 68.1483 83.9254 68.3466 83.3176 68.3457H45.1802C44.8354 68.3457 44.5058 68.2832 44.2013 68.1683L44.0501 68.1078C43.5512 67.8858 43.1273 67.5239 42.8298 67.066C42.5322 66.6081 42.3737 66.0737 42.3735 65.5276V52.302H52.9884C54.1608 52.302 55.1055 53.2669 55.1055 54.4375V54.4527C55.1055 55.6243 56.0612 56.569 57.2337 56.569H71.2631C71.8267 56.5685 72.3671 56.3446 72.766 55.9465C73.1649 55.5483 73.3897 55.0082 73.3913 54.4446C73.3913 53.2689 74.337 52.302 75.5084 52.302H86.1243L86.1233 65.5286Z",
    fill: "url(#paint5_linear_44_2301)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_44_2301",
    x1: 67.2253,
    y1: 37.2559,
    x2: 67.2253,
    y2: -8.80578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEDEDE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A9A9",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_44_2301",
    x1: 61.5322,
    y1: 76.271,
    x2: 61.5322,
    y2: 63.2078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96A1C5",
    stopOpacity: 0.373
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_44_2301",
    x1: 65,
    y1: 80,
    x2: 65,
    y2: 58.5476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#919191",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_44_2301",
    x1: 64.2484,
    y1: 40.0828,
    x2: 64.2484,
    y2: 48.3296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5389F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#416FDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_44_2301",
    x1: 69.3571,
    y1: 64.0555,
    x2: 69.3571,
    y2: 47.2491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6CFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_44_2301",
    x1: 64.2489,
    y1: 52.302,
    x2: 64.2489,
    y2: 68.3457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CA5F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4D6FC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.13e710cf6f75177ab142886ed850a285.svg";
export { ForwardRef as ReactComponent };